import React from 'react';

import FarmProductionRecordAddForm from './FarmProductionRecordAddForm';

export default function FarmProductionRecordAddSowScreen() {
  return (
    <FarmProductionRecordAddForm
      type="SOW"
      title="Add Sowing Records"
      successMessage="Create Sowing Record successfully"
    />
  );
}
